export const AUTHENTICATED = 'MainScreen/AUTHENTICATED'
export const NOT_AUTHENTICATED = 'MainScreen/NOT_AUTHENTICATED' 
export const USER_LOGIN_SUCCESS = 'MainScreen/USER_LOGIN_SUCCESS' 
export const USER_LOGIN_FAIL = 'MainScreen/USER_LOGIN_FAIL'
export const CURRENT_USER_FETCHED = 'MainScreen/CURRENT_USER_FETCHED'
export const DETAILS_FETCHED = 'MainScreen/DETAILS_FETCHED';
